"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * RichWise_Website_API.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfActivityScheduleItemSearchModel = instanceOfActivityScheduleItemSearchModel;
exports.ActivityScheduleItemSearchModelFromJSON = ActivityScheduleItemSearchModelFromJSON;
exports.ActivityScheduleItemSearchModelFromJSONTyped = ActivityScheduleItemSearchModelFromJSONTyped;
exports.ActivityScheduleItemSearchModelToJSON = ActivityScheduleItemSearchModelToJSON;
exports.ActivityScheduleItemSearchModelToJSONTyped = ActivityScheduleItemSearchModelToJSONTyped;
/**
 * Check if a given object implements the ActivityScheduleItemSearchModel interface.
 */
function instanceOfActivityScheduleItemSearchModel(value) {
    return true;
}
function ActivityScheduleItemSearchModelFromJSON(json) {
    return ActivityScheduleItemSearchModelFromJSONTyped(json, false);
}
function ActivityScheduleItemSearchModelFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'orderString': json['orderString'] == null ? undefined : json['orderString'],
        'currentPage': json['currentPage'] == null ? undefined : json['currentPage'],
        'pageSize': json['pageSize'] == null ? undefined : json['pageSize'],
        'aiNo': json['aiNo'] == null ? undefined : json['aiNo'],
    };
}
function ActivityScheduleItemSearchModelToJSON(json) {
    return ActivityScheduleItemSearchModelToJSONTyped(json, false);
}
function ActivityScheduleItemSearchModelToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'orderString': value['orderString'],
        'currentPage': value['currentPage'],
        'pageSize': value['pageSize'],
        'aiNo': value['aiNo'],
    };
}
